import useGetCurrentAliasSetQuery from '@src/hooks/api/queries/useGetCurrentAliasSetQuery';
import { useMemo } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import useAliasGroupContext from '@src/hooks/context/useAliasGroup';
import useAlias from '@src/hooks/useAlias';
import FormattedAlias from '../_shared/Translations/FormattedAlias';

const AliasSelector = () => {
  const { data } = useGetCurrentAliasSetQuery();
  const [aliasGroup, setAliasGroup] = useAliasGroupContext();
  const alias = useAlias();

  const options = useMemo(() => {
    const optionsSet = new Set<string>();
    if (data?.aliasSet) {
      for (const group of Object.keys(data.aliasSet)) {
        optionsSet.add(group);
      }
    }
    return ['default', ...Array.from(optionsSet).sort()];
  }, [data]);

  const isAliasGroupRecognized = useMemo(() => {
    return options.includes(aliasGroup);
  }, [aliasGroup, options]);

  return (
    <FormControl size='small' sx={{ minWidth: 200 }}>
      <InputLabel>
        <FormattedAlias id='Alias Group' />
      </InputLabel>
      <Select
        value={isAliasGroupRecognized ? aliasGroup : 'default'}
        label={alias('Alias Group')}
        onChange={(event: SelectChangeEvent<string>) =>
          setAliasGroup(event.target.value as string)
        }
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AliasSelector;
